import React from "react";
import Header from "../../components/header/Header";

const formations = [
  {
    id: "form-fullstack",
    date: "Mars 2026 - Août 2026",
    titre: "Développeur Web Fullstack",
    organisme: "A2DM Ampefiloha - Antananarivo",
    description:
      "Formation spécialisée dans le développement d'applications web modernes : conception d'interfaces React, développement d'API REST avec Node.js et Express, gestion des bases de données MongoDB, mise en place d'architectures Fullstack, ainsi que l'hébergement des sites et la configuration des noms de domaine.",
},
  {
    id: "form-graphique",
    date: "Janvier 2026 - Mars 2026",
    titre: "Designer Graphique",
    organisme: "A2DM Ampefiloha - Antananarivo",
    description:
      "Formation orientée création graphique et communication visuelle avec Photoshop, Illustrator et InDesign. Acquisition des bases en conception graphique, identité visuelle et supports numériques.",
  },
  {
    id: "form-licence-info",
    date: "Parcours académique",
    titre: "Licence en Informatique",
    organisme: "Chambre de Commerce - Antananarivo",
    description:
      "Formation universitaire axée sur les fondamentaux de l'informatique, la programmation et les technologies numériques.",
  },
  {
    id: "form-licence-gi",
    date: "Parcours académique",
    titre: "Licence en Génie Industriel",
    organisme: "Institut Supérieur de Technologie - Antananarivo",
    description:
      "Formation scientifique et technique orientée optimisation des systèmes industriels, méthodes de production et gestion technique.",
  },
  {
    id: "form-dts-gim",
    date: "Parcours académique",
    titre:
      "Diplôme de Technicien Supérieur en Génie Industriel et Maintenance (Bac +2)",
    organisme: "Institut Supérieur de Technologie - Antananarivo",
    description:
      "Formation technique spécialisée en maintenance industrielle, analyse des équipements et résolution de problèmes techniques.",
  },
];

const experiences = [
  {
    id: "exp-adm-value",
    date: "2022 - Aujourd'hui",
    poste: "Opérateur Multimédia (Presse - Web)",
    entreprise: "ADM Value - Antananarivo",
    description:
      "Participation à la production et à la gestion de contenus numériques destinés aux supports web et multimédias. Cette expérience m'a permis de développer une meilleure compréhension des usages numériques, de la qualité des contenus en ligne et des exigences liées aux plateformes digitales.",
    competences: [
      "Production de contenus numériques",
      "Gestion de supports web",
      "Veille digitale",
      "Rigueur et qualité de publication",
    ],
  },
  {
    id: "exp-connecteo-chef",
    date: "2020 - 2021",
    poste: "Chef d'équipe Service Rétention Clients",
    entreprise: "Connecteo - Antananarivo",
    description:
      "Encadrement d'une équipe dédiée à la fidélisation client. Gestion des objectifs, accompagnement des collaborateurs, analyse des problématiques utilisateurs et mise en place d'actions d'amélioration du service. Cette expérience a renforcé mes compétences en organisation, communication et gestion de projet.",
    competences: [
      "Management d'équipe",
      "Analyse des besoins utilisateurs",
      "Suivi d'indicateurs",
      "Résolution de problèmes",
    ],
  },
  {
    id: "exp-connecteo-agent",
    date: "2019 - 2020",
    poste: "Agent Rétention Clients",
    entreprise: "Connecteo - Antananarivo",
    description:
      "Accompagnement des clients dans leurs demandes, identification des besoins et recherche de solutions adaptées. Cette expérience m'a permis de développer une forte orientation utilisateur, compétence essentielle dans la conception d'interfaces et d'applications centrées sur l'expérience client.",
    competences: [
      "Relation client",
      "Analyse des besoins",
      "Communication professionnelle",
      "Gestion des situations complexes",
    ],
  },
  {
    id: "exp-telma-agent",
    date: "2015 - 2019",
    poste: "Agent Rétention Clients",
    entreprise: "Telma - Antananarivo",
    description:
      "Gestion de la relation client dans un environnement télécom. Traitement des demandes, accompagnement des utilisateurs et compréhension des problématiques liées aux services numériques et aux infrastructures de communication.",
    competences: [
      "Support client",
      "Services numériques",
      "Analyse d'incidents",
      "Communication client",
    ],
  },
];

const CardParcours = ({ item, isExperience = false }) => {
  return (
    <div
      style={{
        position: "relative",
        background: "rgba(255, 255, 255, 0.04)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        borderRadius: "20px",
        padding: "30px",
        marginBottom: "30px",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        boxShadow: "0 15px 35px rgba(0, 0, 0, 0.3)",
        overflow: "hidden",
      }}
    >
      {/* Ligne latérale */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          width: "4px",
          background: "linear-gradient(180deg, #ffd700, #1766ad)",
        }}
      />

      {/* Badge Date */}
      <div
        style={{
          display: "inline-block",
          padding: "6px 14px",
          background: "rgba(255, 215, 0, 0.12)",
          color: "#ffd700",
          fontWeight: 600,
          fontSize: "13px",
          borderRadius: "50px",
          marginBottom: "15px",
          letterSpacing: "0.5px",
          border: "1px solid rgba(255, 215, 0, 0.2)",
        }}
      >
        {item.date}
      </div>

      {/* Titre / Poste */}
      <h3
        style={{
          margin: "0 0 8px 0",
          fontSize: "22px",
          fontWeight: 700,
          color: "#ffffff",
          letterSpacing: "-0.5px",
        }}
      >
        {isExperience ? item.poste : item.titre}
      </h3>

      {/* Sous-titre */}
      <h4
        style={{
          color: "#93c5fd",
          fontWeight: 500,
          fontSize: "15px",
          margin: "0 0 15px 0",
        }}
      >
        {item.organisme || item.entreprise}
      </h4>

      {/* Description */}
      <p
        style={{
          color: "#cbd5e1",
          lineHeight: 1.7,
          margin: 0,
          fontSize: "15px",
        }}
      >
        {item.description}
      </p>

      {/* Badges Compétences */}
      {item.competences && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            marginTop: "20px",
            paddingTop: "15px",
            borderTop: "1px solid rgba(255, 255, 255, 0.08)",
          }}
        >
          {item.competences.map((comp, index) => (
            <span
              key={`${item.id}-skill-${index}`}
              style={{
                padding: "6px 14px",
                borderRadius: "20px",
                background: "rgba(255, 215, 0, 0.1)",
                border: "1px solid rgba(255, 215, 0, 0.3)",
                color: "#ffd700",
                fontSize: "13px",
                fontWeight: 500,
              }}
            >
              {comp}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

const Parcours = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        width: "100%",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      <Header />

      <main
        style={{
          flex: 1,
          padding: "140px 20px 80px",
          background:
            "linear-gradient(135deg, #0f2027, #203a43, #2c5364, #1766ad)",
          color: "#fff",
          backgroundAttachment: "fixed",
        }}
      >
        <div
          style={{
            maxWidth: "900px",
            margin: "0 auto",
          }}
        >
          {/* Header Section */}
          <div
            style={{
              textAlign: "center",
              marginBottom: "70px",
            }}
          >
            <h1
              style={{
                fontSize: "42px",
                fontWeight: 800,
                letterSpacing: "-1px",
                marginBottom: "15px",
                background: "linear-gradient(90deg, #ffffff, #ffd700)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                marginTop: 0,
              }}
            >
              Parcours & Formations
            </h1>
            <p
              style={{
                color: "#cbd5e1",
                fontSize: "18px",
                fontWeight: 400,
                maxWidth: "600px",
                margin: "0 auto",
                lineHeight: 1.6,
              }}
            >
              Une évolution progressive entre technologie, industrie et développement web
            </p>
            <div
              style={{
                width: "80px",
                height: "4px",
                background: "#ffd700",
                margin: "25px auto 0",
                borderRadius: "2px",
              }}
            />
          </div>

          {/* FORMATIONS */}
          <div style={{ marginBottom: "60px" }}>
            <h2
              style={{
                color: "#ffd700",
                fontSize: "26px",
                fontWeight: 700,
                marginBottom: "30px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginTop: 0,
              }}
            >
              <span role="img" aria-label="formation">
                🎓
              </span>{" "}
              Formations
            </h2>
            {formations.map((formation) => (
              <CardParcours key={formation.id} item={formation} />
            ))}
          </div>

          {/* EXPERIENCES */}
          <div style={{ marginBottom: "60px" }}>
            <h2
              style={{
                color: "#ffd700",
                fontSize: "26px",
                fontWeight: 700,
                marginBottom: "30px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginTop: 0,
              }}
            >
              <span role="img" aria-label="expérience">
                💼
              </span>{" "}
              Expériences professionnelles
            </h2>
            {experiences.map((experience) => (
              <CardParcours
                key={experience.id}
                item={experience}
                isExperience
              />
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Parcours;